import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

/**
 * PageSeo component for setting page-specific SEO metadata
 * This helps search engines and social media platforms understand page content
 */
const PageSeo = ({ 
  title,
  description,
  keywords = [],
  canonical = window.location.href,
  ogType = 'website',
  ogImage = '/logo512.png'
}) => {
  // Create the complete page title with brand name
  const pageTitle = title ? `${title} | GPM Tools` : 'GPM Tools - Website Performance Analysis';
  
  // Create comma separated keywords
  const keywordsString = Array.isArray(keywords) ? keywords.join(', ') : keywords;

  return (
    <Helmet>
      {/* Basic metadata */}
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      {keywordsString && <meta name="keywords" content={keywordsString} />}
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

PageSeo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  keywords: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  canonical: PropTypes.string,
  ogType: PropTypes.string,
  ogImage: PropTypes.string
};

export default PageSeo;